import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ZinantisMemberHotelsState } from '../../../../../types/zinantis/members/membersType';
import useTranslate from '../../../../../customHooks/useTranslate';
import Card from '../../../../../muiComponents/Card';
import Title from '../../../../components/Title';
import Menu from '../../../components/Menu';
import encodeBase64 from '../../../../../utils/encodeBase64';
import routes from '../../../../../utils/commonVariables/routes';
import Icon from '../../../../../muiComponents/Icon';
import Status from '../../../../../components/Status';
import { Table, TableRow, TableCell, TableBody } from '@mui/material';
import SearchBar from '../../../../components/SearchBar';
import useLanguage from '../../../../../customHooks/useLanguage';
import Tooltip from '../../../../../muiComponents/Tooltip';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';

interface HotelsSectionProps {
    hotels: ZinantisMemberHotelsState[];
    allHotels: boolean;
}

const HotelsSection = (props: HotelsSectionProps) => {
    const { hotels = [], allHotels } = props;
    const translate = useTranslate();
    const appLanguage = useLanguage();

    const [filterValue, setFilterValue] = useState('');

    const getVisibleDescription = (
        descriptions: ZinantisMemberHotelsState['descriptions']
    ) => {
        if (!descriptions?.length) return null;
        const descriptionInAppLanguage = descriptions.find(
            desc => desc.code === appLanguage
        );
        const descriptionInDefaultLanguage = descriptions.find(
            desc => desc.code === 'en'
        );

        return (
            descriptionInAppLanguage ||
            descriptionInDefaultLanguage ||
            descriptions[0]
        );
    };

    if (allHotels) {
        return (
            <div
                className='flex-column gap-10 padding-top-20'
                style={{ borderTop: '1px solid var(--border)' }}
            >
                <h2 className='lateral-panel__title text-size-20'>
                    {translate('connected-hotels')}
                </h2>
                <p>{translate('all_hotels_description')}</p>
                <Link
                    className='width-content gap-10 flex flex-baseline'
                    to={routes.landingPrivate + routes.propertyList}
                >
                    <Icon iconName={commonIcons.HOTEL} />
                    {translate('go_to_your_properties')}
                </Link>
            </div>
        );
    }

    return (
        <div
            className='flex flex-column gap-20  padding-top-20'
            style={{ borderTop: '1px solid var(--border)' }}
        >
            <h2 className='lateral-panel__title text-size-20'>
                {translate('connected-hotels')}
            </h2>
            <SearchBar
                placeholder={translate('search_hotel')}
                value={filterValue}
                onChange={e => setFilterValue(e.target.value)}
                onClear={() => setFilterValue('')}
            />
            <Card style={{ cursor: 'auto', overflow: 'hidden' }}>
                <Table>
                    <TableBody>
                        {hotels
                            .filter(hotel =>
                                hotel.hotelName
                                    .toLowerCase()
                                    .includes(filterValue.toLowerCase())
                            )
                            .map(hotel => {
                                const visibleHotelDescription =
                                    getVisibleDescription(hotel.descriptions);
                                return (
                                    <TableRow key={hotel.id}>
                                        <TableCell>
                                            <div className='flex-column gap-5'>
                                                <div className='flex flex-between flex-align-center'>
                                                    <div className='flex gap-20'>
                                                        <Tooltip titleText='hotel'>
                                                            <span>
                                                                <Title>
                                                                    {
                                                                        hotel.hotelName
                                                                    }
                                                                </Title>
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip titleText='City'>
                                                            <div className='flex flex-align-center gap-5'>
                                                                <Icon
                                                                    iconName={
                                                                        'LocationOn'
                                                                    }
                                                                    className='text-primary-400'
                                                                />
                                                                {hotel.city}
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                    <div className='flex gap-10'>
                                                        <Tooltip titleText='status'>
                                                            <span className='flex flex-align-center'>
                                                                <Status
                                                                    text={
                                                                        hotel.status
                                                                    }
                                                                    color={
                                                                        hotel.statusColor
                                                                    }
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                        <Menu
                                                            menuItems={[
                                                                {
                                                                    text: 'open-hotel-details',
                                                                    icon: 'OpenInNew',
                                                                    onClick:
                                                                        () => {
                                                                            const url = `/your-property/${encodeBase64(
                                                                                hotel.idSupplierHotel
                                                                            )}/`;
                                                                            window.open(
                                                                                url,
                                                                                url
                                                                            );
                                                                        },
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>

                                                {visibleHotelDescription ? (
                                                    <Tooltip titleText='description2'>
                                                        <p className='text-size-12'>
                                                            {
                                                                visibleHotelDescription.description
                                                            }
                                                        </p>
                                                    </Tooltip>
                                                ) : null}
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </Card>
        </div>
    );
};

export default HotelsSection;
